export var DbOperations;
(function (DbOperations) {
    DbOperations["Create"] = "create";
    DbOperations["Update"] = "update";
    DbOperations["Remove"] = "remove";
})(DbOperations || (DbOperations = {}));
export var DeliveryMethods;
(function (DeliveryMethods) {
    DeliveryMethods["POST"] = "POST";
    DeliveryMethods["GET"] = "GET";
    DeliveryMethods["PUT"] = "PUT";
    DeliveryMethods["PATCH"] = "PATCH";
    DeliveryMethods["DELETE"] = "DELETE";
})(DeliveryMethods || (DeliveryMethods = {}));
